import Box from '@mui/material/Box';
import Container from '@mui/material/Container';
import Typography from '@mui/material/Typography';
import Button from '@mui/material/Button';
import Stack from '@mui/material/Stack';
import { useTranslation } from 'react-i18next';
import EcosystemVisual from './EcosystemVisual.jsx';
import { Eyebrow } from './ui.jsx';
import { tokens } from '../theme.js';

export default function Hero() {
  const { t } = useTranslation();

  return (
    <Box component="section" sx={{ background: `linear-gradient(160deg, ${tokens.dark} 0%, ${tokens.dark2} 100%)`, color: '#fff' }}>
      <Container
        maxWidth="lg"
        sx={{
          py: { xs: 8, md: 12 },
          display: 'grid',
          gridTemplateColumns: { xs: 'minmax(0, 1fr)', md: 'minmax(0, 1.1fr) minmax(0, 0.9fr)' },
          alignItems: 'center',
          gap: { xs: 6, md: 8 },
        }}
      >
        <Box sx={{ minWidth: 0 }}>
          <Eyebrow onDark>{t('hero.eyebrow')}</Eyebrow>
          <Typography variant="h1">{t('hero.title')}</Typography>
          <Typography sx={{ color: tokens.mutedOnDark, fontSize: '1.1rem', maxWidth: '46ch', mt: 2.5, mb: 4 }}>
            {t('hero.subtitle')}
          </Typography>
          <Stack direction={{ xs: 'column', sm: 'row' }} spacing={1.5} useFlexGap>
            <Button variant="contained" size="large" href="#solutions" sx={{ width: { xs: '100%', sm: 'auto' } }}>
              {t('hero.ctaProducts')}
            </Button>
            <Button
              variant="outlined"
              size="large"
              href="#contact"
              sx={{
                width: { xs: '100%', sm: 'auto' },
                color: '#fff',
                borderColor: tokens.lineOnDark,
                '&:hover': { borderColor: 'primary.main', color: 'primary.main', bgcolor: 'transparent' },
              }}
            >
              {t('hero.ctaContact')}
            </Button>
          </Stack>
        </Box>
        <EcosystemVisual />
      </Container>
    </Box>
  );
}
